import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import styles from './styles.module.css';
/**
 * `<Skeleton />` Элемент для отображения скелетона компонента
 */
export const Skeleton = /*#__PURE__*/forwardRef(({
  children,
  variant,
  size,
  className,
  width,
  height,
  invert = false,
  showLoading = true,
  ...props
}, ref) => {
  const isWidth = !!width;
  const isHeight = !!height;
  const style = useMemo(() => ({
    ...(isWidth && {
      width
    }),
    ...(isHeight && {
      height
    })
  }), [isWidth, width, isHeight, height]);
  const roundingSize = props == null ? void 0 : props.roundingSize;
  const classNames = useMemo(() => clsx(styles.skeleton, variant && styles[variant], size && styles[size], roundingSize && styles[`r-${roundingSize}`], invert && styles.invert, className), [variant, size, roundingSize, invert, className]);
  const testId = props['data-testid'] || 'skeleton';
  if (!showLoading) {
    return children ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "skeleton-children"
    }, children) : null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    style: style,
    "data-testid": testId,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.skeletonInner, children && styles.witchChildren),
    "data-testid": "skeleton-inner"
  }, children ? (/*#__PURE__*/React.createElement("div", {
    style: {
      visibility: 'hidden'
    },
    "data-testid": "skeleton-children"
  }, children)) : null));
});